import { css } from "lit"

export const posts = css`
	:host {
		display: flex;
		flex-direction: column;
		align-items: center;
		gap: 2rem;
		box-sizing: border-box;
		font-family: var(--headings-font-family);
	}
	* {
		box-sizing: border-box;
	}
	.post-list {
		width: 100%;
		display: flex;
		flex-wrap: wrap;
		gap: 1.5rem;
		justify-content: space-between;
		flex-direction: row;
	}

	button {
		border-radius: 4rem;
		background: linear-gradient(0deg, #F53D73 0%, #F53D73 100%), rgba(253, 231, 238, 0.00);
		color: #FDE7EE;
		text-align: center;
		font-size: 1rem;
		font-style: normal;
		text-decoration: none;
		font-weight: 400;
		padding: 0.5rem 3rem;
		display: inline-block;
		outline: none;
		border: none;
	}

	button:hover {
		background: linear-gradient(0deg, #C42755 0%, #C42755 100%), rgba(253, 231, 238, 0.20);
	}

	single-post {
	width: calc(33.333% - 1.5rem);
	}

	single-post:nth-child(4n) {
	width: 100%;
	}


	@media screen and (max-width: 1030px) {
		.post-list {
			gap: 1.25rem;
			flex-direction: column;
		}

	single-post {
	width: 100%;
	}

		single-post:nth-child(n + 2) {
			width: 100%;
		}


	}
`
